<script setup>
import {reactive, onMounted, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {userStore} from "@/Stores/UserStore";
import {ToastUtil} from "@/Utils/ToastUtil";

const form = ref(null);

const data = reactive({
  valid: true,
  oldPasswordShow: false,
  newPasswordShow: false,
  newPassword: null,
  oldPassword: null,
  loading: false,
});

const reset = () => {
  form.value.reset()
}

const save = async () => {
  data.loading = true;
  ApiWrapper.post('user-management','change-my-password', {
    newPassword: data.newPassword,
    oldPassword: data.oldPassword,
    accessToken: userStore.accessToken.toString()
  })
    .then((response) => {
      reset();
      data.loading = false;

      ApiWrapper.signOut();

      ToastUtil.successMsg('Changed password');
    })
    .catch((e) => {
      ToastUtil.error(e);

      data.loading = false;
    })
}

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-toolbar-title>Change Password</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-spacer></v-spacer>
      </v-toolbar>

      <!-- Change Password Form -->
      <v-form ref="form" v-model="data.valid" lazy-validation>
        <v-row class="mx-4">
          <v-col cols="12" sm="12">
            <v-text-field
                v-model="data.oldPassword"
                label="Old Password"
                :rules="[v => !!v || 'Password is required']"
                :append-icon="data.oldPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
                :type="data.oldPasswordShow ? 'text' : 'password'"
                @click:append="data.oldPasswordShow = !data.oldPasswordShow"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field
                v-model="data.newPassword"
                label="New Password"
                :rules="[v => !!v || 'New password is required']"
                :append-icon="data.newPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
                :type="data.newPasswordShow ? 'text' : 'password'"
                @click:append="data.newPasswordShow = !data.newPasswordShow"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn
            class="ml-4 mb-2"
            color="primary"
            @click="save"
            :disabled="!data.valid || data.loading"
            :loading="data.loading"
        >
          Change Password
        </v-btn>
        <v-btn
            v-if="!data.loading"
            color="success"
            class="ml-2 mb-2"
            @click="reset"
        >
          Reset
        </v-btn>
      </v-form>
    </v-card>
  </v-container>
</template>

<style scoped>
[v-cloak] {
  display: none;
}
.v__card__title__color {
  color: #1976D2;
}
</style>